import { LinearProgress } from "@material-ui/core";
import React from "react";

export default function TableLoading() {
  return <LinearProgress />;
}
